import React from "react";
import "./styles.css";
import ScrollIcon from "../../../assets/icons/scroll-bar.png";

function ScrollMessage() {
  return (
    <p className="scroll">
      Desliza
      <img className="scroll__icon" src={ScrollIcon} alt="scroll icon" />
      para más información
    </p>
  );
}

export default ScrollMessage;
